export default "/static/6f716a0bfeb730c6.png"